import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import RowHeading from '../row-heading';
import { useChallenges } from '../../state-management/server-state/use-challenges';
import { isVaultVue } from '../../util/is-vault-vue';
import { Text } from './text';
import { FeatureFlag } from '../../types';
import { useFeatureFlags } from '../../hooks/use-feature-flags';
import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import { useSoftwareNumber } from '../../state-management/selectors/use-software-number';
import { useEquipmentType } from '../../state-management/selectors/use-equipment-type';
import CardSeries from '../cards/series';
import { intensityConverter } from '../../util/intensity';
import { GlobalText } from '../../i18n/global-text';
import CardSkeleton from '@ifit/mp-card-skeleton';
import './index.scss';
import { useStationaryConsoleList } from '../../state-management/server-state/use-stationary-console-list';

const skeletonCards = Array(10).fill(0);

export default function ChallengesRow(): JSX.Element {
  const featureFlags = useFeatureFlags([FeatureFlag.Challenges]);
  const isMatrixCommerical = useMatrixCommercial();
  const softwareNumber = useSoftwareNumber();
  const equipmentType = useEquipmentType();
  const stationaryConsole = useStationaryConsoleList(softwareNumber, equipmentType);
  const optionalEquipmentType = stationaryConsole.data ? stationaryConsole?.data[0].equipmentType : null;
  const { data, isFetching, isLoading, isSuccess, error } = useChallenges(optionalEquipmentType);
  const noValidData = !data || data.length === 0;
  const errorWithNoCachedData = error && noValidData;
  const successWithNoData = noValidData && isSuccess;
  const hideRow =
    errorWithNoCachedData ||
    successWithNoData ||
    featureFlags[FeatureFlag.Challenges] !== true ||
    isMatrixCommerical ||
    isVaultVue(softwareNumber);

  if (hideRow) {
    return null;
  }

  let content: JSX.Element[];

  if (isLoading) {
    content = skeletonCards.map((_, index) => <CardSkeleton key={index} className="custom" />);
  } else {
    content = data.map((challenge) => {
      const navigationUrl = `https://www.ifit.com/programDetails/${challenge.item.itemId}`;
      const clickHandler = getUserNavigationHandler(navigationUrl, ROWTITLES.CHALLENGES_WORKOUTS);
      const formattedRating = challenge.item.rating.average ? `${challenge.item.rating.average}` : null;
      return (
        <CardSeries
          key={challenge.item.itemId}
          onClick={clickHandler}
          imageUrl={challenge.item.image}
          leadLine={intensityConverter(challenge.item.intensity)}
          averageRating={formattedRating}
          title={challenge.item.title}
          callToAction={Text.viewChallenge}
          tagPrimary={GlobalText.numberOfWorkouts(challenge.item.workouts.length)}
        />
      );
    });
  }

  return (
    <div className="row-challenges">
      <RowHeading title={Text.title} fetching={isFetching} link="https://www.ifit.com/library?page=challenges" />
      <div className="cards" style={{ ['--cards-per-row' as any]: content.length }}>
        {content}
      </div>
    </div>
  );
}
